import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';

import { Routes, RouterModule } from '@angular/router';
import{ GrayBarHeaderComponent } from '../gray_bar_header/gray_bar_header.component';

@NgModule({
    imports: [
      CommonModule
      ,RouterModule
    ],
    declarations: [GrayBarHeaderComponent],
    exports: [GrayBarHeaderComponent],
    schemas:[ CUSTOM_ELEMENTS_SCHEMA ]
  })

export class GrayBarHeaderModule { }